import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const greetings = [
  { text: 'Hello', font: 'font-mea' },
  { text: 'नमस्ते', font: 'font-hindi-display' },
  { text: 'নমস্কার', font: "font-['Noto_Serif_Bengali']" },
  { text: 'مرحباً', font: 'font-mea' },
  { text: 'Hallo', font: 'font-mea' }
];

const LandingScreen = ({ onComplete }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let completionTimer;

    const interval = window.setInterval(() => {
      setIndex((currentIndex) => {
        if (currentIndex < greetings.length - 1) {
          return currentIndex + 1;
        }

        window.clearInterval(interval);
        completionTimer = window.setTimeout(onComplete, 400);
        return currentIndex;
      });
    }, 500);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(completionTimer);
    };
  }, [onComplete]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center cursor-default"
      initial={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.5,
          ease: 'easeInOut'
        }
      }}
    >
      <div className="relative w-full text-center flex justify-center items-center h-full">
        <AnimatePresence mode="wait">
          <motion.h1
            key={index}
            initial={{ opacity: 0, filter: 'blur(10px)', scale: 0.9 }}
            animate={{ opacity: 1, filter: 'blur(0px)', scale: 1 }}
            exit={{ opacity: 0, filter: 'blur(10px)', scale: 1.1 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            className={`text-white leading-none ${greetings[index].font}`}
            style={{
              fontSize: 'clamp(42px, 10vw, 130px)',
              fontWeight: '400',
              color: '#ffffff'
            }}
          >
            {greetings[index].text}
          </motion.h1>
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default LandingScreen;